import { combineReducers } from "redux";
import session from "./session";
import page from "./page";
import profile from "./profile";
import performance from "./performance";
import site from "./site";
import summary from "./summary";
import notification from "./notification";
import settings from "./settings";
import option from "./option";
import version from "./version";
import unit from "./unit";
import operation from "./operation";
import plan from "./plan";
import vpp from "./vpp";
import feature from "./feature";
import registration from "./registration";

const rootReducer = combineReducers({
  session,
  page,
  profile,
  performance,
  site,
  summary,
  notification,
  settings,
  option,
  version,
  unit,
  operation,
  plan,
  vpp,
  feature,
  registration,
});

export default rootReducer;
